import * as JSONS from "./data";
const pageDesigns = [
    {
      id: 1,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign01.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT01.jpg",
      metaData:JSONS.DESIGN_01,
      label: "Design 01",
    },
    {
      id: 2,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign02.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT02.jpg",
      metaData:JSONS.DESIGN_02,
      label: "Design 02",
    },
    {
      id: 3,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign03.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT03.jpg",
      metaData:JSONS.DESIGN_03,
      label: "Design 03",
    },
    {
      id: 4,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign04.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT04.jpg",
      metaData:JSONS.DESIGN_04,
      label: "Design 04",
    },
    {
      id: 5,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign05.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT05.jpg",
      metaData:JSONS.DESIGN_05,
      label: "Design 05",
    },
    {
      id: 6,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign06.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT06.jpg",
      metaData:JSONS.DESIGN_06,
      label: "Design 06",
    },
    {
      id: 7,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign07.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT07.jpg",
      metaData:JSONS.DESIGN_07,
      label: "Design 07",
    },
    {
      id: 8,
      url: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesign08.jpg",
      thumb: "https://freshflowxyz.b-cdn.net/assets/pageDesigns/dynamicPageDesignT08.jpg",
      metaData:JSONS.DESIGN_08,
      label: "Design 08",
    },
  ];

  export default pageDesigns